import * as React from 'react';

import { useScrollToHash } from 'lib/use-scroll-to-hash';
import { useRouter } from 'next/router';

import { getPropsLandingBlockThreeContainer } from './landing-block-three-container.props';

export const LandingBlockThreeContainer: React.FC = () => {
  const props = getPropsLandingBlockThreeContainer();
  const router = useRouter();
  const [activeSection, setActiveSection] = React.useState<string>(props.sections[0].id);

  React.useEffect(() => {
    if (router.asPath.includes('#')) {
      const hash = router.asPath.split('#')[1].split('--')[0];
      if (props.sections.some((Section) => Section.id === hash)) {
        setActiveSection(hash);
      }
    }
  }, [router, props.sections]);

  useScrollToHash();

  return (
    <>
      {props.sections.map((section) => (
        <div
          key={section.id}
          role="Sectionpanel"
          id={`Sectionpanel-${section.id}`}
          aria-labelledby={`Section-${section.id}`}
          hidden={activeSection !== section.id}
        >
          {section.content}
        </div>
      ))}
    </>
  );
};
